import { render } from "./App.vue?vue&type=template&id=b42dff2e"
const script = {}

import exportComponent from "C:\\Users\\Admin\\Desktop\\qrpay\\pay-checkout-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__